import request from '../utils/request';

const BASE_URL = '/system-config';

// 系统配置 API
export const systemConfigApi = {
  // 分页查询系统配置列表
  // data: { page, pageSize, configType, configGroup, configKey }
  pageConfigs: (data) => {
    return request.post(`${BASE_URL}/page`, data);
  },

  // 获取系统配置详情
  getConfigById: (id) => {
    return request.get(`${BASE_URL}/${id}`);
  },

  // 根据配置键获取配置
  getConfigByKey: (configKey) => {
    return request.get(`${BASE_URL}/key/${configKey}`);
  },

  // 创建系统配置
  createConfig: (data) => {
    return request.post(BASE_URL, data);
  },

  // 更新系统配置
  updateConfig: (id, data) => {
    return request.put(`${BASE_URL}/${id}`, data);
  },

  // 更新配置值
  updateConfigValue: (configKey, configValue) => {
    // 确保 configValue 是字符串，因为后端接口接收 @RequestBody String configValue
    // Spring Boot 的 @RequestBody String 会读取请求体的原始内容作为字符串
    const value = typeof configValue === 'string' ? configValue : String(configValue);
    return request.put(`${BASE_URL}/value/${configKey}`, value);
  },

  // 启用或禁用配置
  updateEnabledStatus: (id, enabled) => {
    return request.put(`${BASE_URL}/${id}/enabled?enabled=${enabled}`);
  },

  // 删除系统配置
  deleteConfig: (id) => {
    return request.delete(`${BASE_URL}/${id}`);
  },

  // 根据配置类型获取配置列表
  listByConfigType: (configType) => {
    return request.get(`${BASE_URL}/type/${configType}`);
  },

  // 根据配置分组获取配置列表
  listByConfigGroup: (configGroup) => {
    return request.get(`${BASE_URL}/group/${configGroup}`);
  }
};

